import { render, staticRenderFns } from "./PearsonFooter.vue?vue&type=template&id=9b943aac&scoped=true"
import script from "./PearsonFooter.vue?vue&type=script&lang=js"
export * from "./PearsonFooter.vue?vue&type=script&lang=js"
import style0 from "./PearsonFooter.vue?vue&type=style&index=0&id=9b943aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b943aac",
  null
  
)

export default component.exports